import {
  GetTokenOptions,
  IAction,
  OrgType,
} from '@sennder/senn-node-microfrontend-interfaces'

import { auth } from '@/modules/auth'
import { featureFlag } from '@/services/featureFlagProvider'

const DEFAULT_AUDIENCE = 'https://api.cloud.sennder.com'
const DEFAULT_ORG_ID = 'sennder'
const DEFAULT_ORG_TYPE = OrgType.ORGANIZATION

const defaultTokenOptions: GetTokenOptions = {
  usePopup: false,
  throwException: false,
}

export const getAuthToken = async (
  options: GetTokenOptions = defaultTokenOptions
) => {
  if (!auth.value) {
    throw new Error('[tms-shell - getAuthToken]: Auth module is not loaded')
  }

  const audience = options.audience || DEFAULT_AUDIENCE
  const enrichedOptions = { ...options, audience }

  const token = (await auth.value.getAuthToken(enrichedOptions)) || null

  return token
}

export const getAuthHeader = async (
  options: GetTokenOptions = defaultTokenOptions
) => {
  const token = await getAuthToken(options)
  return token ? `Bearer ${token}` : null
}

export async function getCommonHeaders() {
  if (!auth.value) {
    throw new Error('[tms-shell - getCommonHeaders]: Auth module is not loaded')
  }

  const headers = await auth.value.getCommonHeaders(DEFAULT_AUDIENCE)

  // We're decoupling auth headers from Chartering data, see details here:
  // https://sennder.atlassian.net/wiki/spaces/PLE/pages/4967661569/Decoupling+the+sennTMS+auth+flow+from+the+Chartering+Office+concept
  return featureFlag.getFeatureFlag('DISABLE_CHARTERING-SHARED-DATA') === true
    ? {
        ...headers,
        'X-Org-Type': DEFAULT_ORG_TYPE,
        'X-Org-Id': DEFAULT_ORG_ID,
      }
    : headers
}

export async function getPermissions(actions: IAction[]) {
  if (!auth.value) {
    throw new Error('[tms-shell - getPermissions]: Auth module is not loaded')
  }
  return await auth.value.getPermissions(actions, DEFAULT_AUDIENCE)
}

/**
 * @deprecated to be removed https://sennder.atlassian.net/wiki/spaces/PLE/pages/4967661569/Decoupling+the+sennTMS+auth+flow+from+the+Chartering+Office+concept
 */
export async function getOrgTypeAndOrgIdOrFail() {
  if (!auth.value) {
    throw new Error(
      '[tms-shell - getOrgTypeAndOrgIdOrFail]: Auth module is not loaded'
    )
  }
  return await auth.value.getOrgTypeAndOrgIdOrFail()
}
